<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-14 14:00:00
-->
<template>
  <div :class="['model',theme]" :style="model" v-if="list.length != 0">
    <div v-if="title" class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="itemImg">
            <img :src="item.img" />
          </div>
          <div class="itemInfo">
            <div class="name">{{ item.name }}</div>
            <div class="info">{{ item.info }}</div>
            <div class="border-bottom" :style="{ backgroundColor: $util.rgbToRgba(bColor, 0.2) }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "title", "textColor",'theme'],
  data() {
    return { list: [] };
  },
  created() {},
  methods: {},
  watch: {
    data: {
      handler(val) {
        console.log(val);
        let num = 1;
        let list = val.map((item) => {
          let info = "";
          if (num == item.rank) {
            info = `助力值排行第${item.rank}名可领取`;
          } else {
            info = `助力值排行第${num}名到${item.rank}名可领取`;
          }
          num = item.rank + 1;
          return {
            ...item,
            info,
          };
        });
        this.list = list;
      },
      deep: true,
    },
  },
  computed: {
    model() {
      const { bColor } = this;
      if (this.type == "purchase") {
        return { border: `none`, backgroundColor: "" };
      }
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(bColor, 0.5) ,
        };
      }
      return { borderColor: bColor };
    },
  },
};
</script>
<style lang="scss" scoped>
.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid  #fff;
  box-sizing: border-box;

  &.theme2{
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background: rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 26px 15px 13px;
      max-height: 252px;
      overflow: auto;

      .item {
        display: flex;
        align-items: center;
        padding: 6px 0;
        position: relative;

        &:last-child{
          .border-bottom{
            display: none;
          }
        }

        .border-bottom{
          content: ' ';
          height: 1px;
          position: absolute;
          left: 88px;
          right: 0;
          bottom: 0;
        }

        .itemImg {
          width: 72px;
          height: 72px;
          background-color: #F0F0F0;
          border-radius: 4px;
          overflow:hidden;

          img {
            width: 72px;
            height: 72px;
            object-fit: contain;
          }
        }

        .itemInfo {
          flex: 1;
          margin-left: 16px;

          .name {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .info {
            font-size: 12px;
            line-height: 16px;
            color: #595959;
          }
        }
      }

      .item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
